import TheGrid from '@/views/products/divisions/grid'
import Edit from '@/views/products/divisions/edit'

export default {
  path: '/products/divisions',
  redirect: '/products/divisions/index',
  name: 'divisions',
  meta: {
    auth: {
      redirect: {
        name: 'divisions.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Produtos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'divisions.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'divisions.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'divisions.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
